import classNames from 'classnames';
import { Heading, List } from 'yoso';
import { Ranking } from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import { LeaderboardThumbnail } from '~/components/Challenge/Leaderboard/Thumbnail/LeaderboardThumbnail';
import { T } from '~/components/I18n';
import { Medal } from '~/components/Icon/Medal/Medal';
import { format, formatKaia } from '~/components/Util/number';
import styles from './ChallengeLeaderboardTable.module.scss';

export type ChallengeLeaderboardTableProps = {
  className?: string;
  items?: (Ranking & { me?: boolean })[];
};
export const ChallengeLeaderboardTable = ({
  className,
  items = [],
}: ChallengeLeaderboardTableProps) => (
  <List className={classNames(styles.root, className)}>
    <li className={styles.header}>
      <div>
        <T name="citizen_challenge_ranking_ranking_pc" />
      </div>
      <div>
        <T name="citizen_challenge_ranking_total_score_pc" />
      </div>
      <div>
        <T name="citizen_challenge_reward_estimation" />
      </div>
    </li>
    {items.map(({ rank, me, profileImageUrl, nickname, score, rewardAmount, rewardCurrency }) => (
      <li key={rank} className={classNames({ [styles.me]: me })}>
        <div className={styles.rank}>
          <Medal className={styles.medal} value={rank} />
          <LeaderboardThumbnail
            className={styles.thumbnail}
            me={me}
            src={profileImageUrl}
            alt={nickname}
          />
          <Heading level={6} className={styles.heading}>
            {nickname}
          </Heading>
        </div>
        <div className={styles.score}>
          <strong>
            <T name="citizen_unit_score" options={[format(score)]} />
          </strong>
        </div>
        <div className={styles.reward}>
          <strong>
            {formatKaia(rewardAmount || 0)} {rewardCurrency}
          </strong>
        </div>
      </li>
    ))}
  </List>
);
